<template>
  <unicom-layout-cartao semFiltro>
    <unicom-linha class="linha-embaixo">
      <unicom-coluna sm="12" style="padding-bottom: 24px">
        <div class="titulo negrito cor-fonte fonte-primaria">
          Especialidades e Serviços Prestados
        </div>
      </unicom-coluna>
    </unicom-linha>

    <unicom-linha style="min-height: 76px">
      <unicom-coluna sm="6" :class="espacamentoMobile">
        <custom-campo-texto
          v-model="especialidadesServicosPrestados.especialidades"
          :icone="especialidadesServicosPrestados.especialidades ? 'x' : ''"
          :mensagemErro="errors.especialidades"
          @click-icone="especialidadesServicosPrestados.especialidades = ''"
          @input="validate('especialidades')"
          maxCaracteres="250"
          ladoIcone="direito"
          clickIcone
          colorPlaceholder="#9E9E9E"
          placeholder="Especialidades"
          titulo="Especialidades *"
          type="especialidades"
        />
      </unicom-coluna>
      <unicom-coluna sm="6" :class="espacamentoMobile">
        <custom-campo-texto
          v-model="especialidadesServicosPrestados.demaisServicos"
          :icone="especialidadesServicosPrestados.demaisServicos ? 'x' : ''"
          :mensagemErro="errors.demaisServicos"
          @click-icone="especialidadesServicosPrestados.demaisServicos = ''"
          @input="validate('demaisServicos')"
          ladoIcone="direito"
          clickIcone
          colorPlaceholder="#9E9E9E"
          placeholder="Demais serviços"
          titulo="Demais serviços"
        />
      </unicom-coluna>
    </unicom-linha>
  </unicom-layout-cartao>
</template>

<script>
import EspecialidadesServicosPrestadosMixin from "@/views/RecursosPropriosQuestionarios/shared/mixins/questionarios/EspecialidadesServicosPrestadosMixin";

import CustomCampoTexto from "@/views/RecursosPropriosQuestionarios/shared/CampoTexto/CampoTexto.vue";

export default {
  mixins: [EspecialidadesServicosPrestadosMixin],
  components: {
    CustomCampoTexto
  },
  data() {
    return {};
  },
  methods: {},
  computed: {
    /**
     * Verifica se a tela está no viewport mobile e se estiver, retorna uma classe que da o espaçamento para cima
     */
    espacamentoMobile() {
      return this.$breakpoint.smAndDown ? "mt-4" : "";
    }
  },
  watch: {}
};
</script>

<style scoped>
.linha-embaixo {
  padding-bottom: 24px;
  border-bottom: 1px solid #ebebeb;
  margin-bottom: 24px;
}
</style>
